"use strict";

import { isEscape, returnFocus, trapFocus } from "./utils.js";

class MaterialCalculator {
    constructor() {
        this.openButton = document.querySelector('[href="#calculator"]');
        this.calculator = document.getElementById('materials-calculator');

        // we should always have the calculator, but check anyway
        if (!this.openButton || !this.calculator) {
            return;
        }

        this.openButton.setAttribute('aria-controls', 'materials-calculator');

        this.closeButton = document.getElementById('calc-dismiss');
        this.inputs = document.querySelectorAll('.calc-input');
        this.result = document.getElementById('calc-result');
        this.lengthInput = document.getElementById('calc-length');
        this.widthInput = document.getElementById('calc-width');
        this.depthInput = document.getElementById('calc-depth');

        this.openButton.addEventListener("click", this.open.bind(this));
        this.closeButton.addEventListener("click", this.close.bind(this));

        this.inputs.forEach(input => {
            input.addEventListener("change", this.calculateTotal.bind(this))
        });

        document.body.addEventListener('keyup', e => {
            if (isEscape(e)) {
                this.close(e);
            }
        });
    }

    open(e) {
        e.preventDefault();
        window.returnFocusTo = this.openButton;
        trapFocus(this.calculator);
        this.calculator.classList.add('show');
        this.calculator.setAttribute('aria-hidden', false);
    }

    close(e) {
        e.preventDefault();
        this.calculator.classList.remove('show');
        this.calculator.setAttribute('aria-hidden', true);
        returnFocus();
    }

    calculateTotal() {
        let num = Number(this.lengthInput.value) * Number(this.widthInput.value) * (Number(this.depthInput.value) * .083) / 27;
        this.result.value = num.toFixed(2);
    }

}

new MaterialCalculator();
